import {
  IBomPartPrice,
  IUpsertComponentCompaniesPayload,
  IUpsertComponentCompaniesResponse,
  IValidateBomPart,
} from 'bom/types';
import { formatElementApiKey } from 'bom/utils';
import { mapRecordFromServer, mapRecordsFromServer } from 'core/mappers';
import { partfinitiClient } from 'core/services';
import { GetManyResponse, GetOneResponse } from 'core/types';
import { getQueryStringToSnakeCase } from 'core/utils';
import { IJobPart, IJobPartListRequestPayload, IUpsertJobPartPayload } from 'jobs/types';

export const getJobParts = async (
  requestPayload: IJobPartListRequestPayload,
  signal?: AbortSignal
): Promise<GetManyResponse<IJobPart>> => {
  const { data } = await partfinitiClient.get(
    `/bom/part/parts?${getQueryStringToSnakeCase(requestPayload)}`,
    signal
  );

  return mapRecordsFromServer<IJobPart>(data.data, data.recordsFiltered, data.totals);
};

export const upsertJobPart = async (data: IUpsertJobPartPayload) =>
  partfinitiClient.postForm('/bom/part/save', data, {
    includeNullValues: true,
    toSnakeCase: formatElementApiKey,
  });

export const changeJobPart = async (data: IUpsertJobPartPayload) =>
  partfinitiClient.postForm('/bom/part/change-part', data, {
    includeNullValues: true,
  });

export const validatePart = async (
  payload: {
    number: string;
    manufacturerId: number;
  },
  signal?: AbortSignal
): Promise<GetOneResponse<IValidateBomPart>> => {
  const { data } = await partfinitiClient.get(
    `/bom/part/validate-part?${getQueryStringToSnakeCase(payload, {
      removeNullValues: true,
    })}`,
    signal
  );

  return mapRecordFromServer<IValidateBomPart>(data, data.success);
};

export const calculatePrices = async (
  payload: {
    number: string;
    manufacturerId: number;
    quantity: number;
    uom: string;
    bomId: number;
  },
  signal?: AbortSignal
): Promise<GetOneResponse<IBomPartPrice>> => {
  const { data } = await partfinitiClient.get(
    `/bom/part/prices?${getQueryStringToSnakeCase(payload, { removeNullValues: true })}`,
    signal
  );

  return mapRecordFromServer<IBomPartPrice>(data.prices, data.success);
};

export const reorderJobParts = async (
  data: IUpsertComponentCompaniesPayload
): Promise<IUpsertComponentCompaniesResponse> =>
  partfinitiClient.postForm('/bom/component-company-edit/save-bulk', data, {
    includeNullValues: true,
  });
